import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { COLLECTIONS_SUMMARY } from "./apiRoutes";

// Define the expected response type
interface CollectionsSummaryData {
  month: string;
  invoicedAmount: number;
  collectedAmount: number;
}

interface CollectionsSummaryResponse {
  data: { items: CollectionsSummaryData[] };
}

interface CollectionsSummaryParams {
  year?: number;
  schoolId?: string;
}

const fetchCollectionsSummary = async (params?: CollectionsSummaryParams) => {
  const response = await axiosAuth.get<CollectionsSummaryResponse>(COLLECTIONS_SUMMARY, {
    params: {
      year: params?.year || new Date().getFullYear(),
      schoolId: params?.schoolId,
    },
  });
  return response.data;
};

export const useGetCollectionsSummaryQuery = (
  params?: CollectionsSummaryParams,
  queryParams?: UseQueryOptions<CollectionsSummaryResponse, Error, CollectionsSummaryResponse, ["collectionsSummary", CollectionsSummaryParams]>
) =>
  useQuery<CollectionsSummaryResponse, Error, CollectionsSummaryResponse, ["collectionsSummary", CollectionsSummaryParams]>({
    queryKey: ["collectionsSummary", params || {}],
    queryFn: () => fetchCollectionsSummary(params),
    ...(queryParams as any),
  });
